import { isProduction } from './environment'

/**
 * Generic host resolver that returns production or staging URL based on environment level
 */
function resolveHost( prodHost: string, stagingHost: string ): string {
	return isProduction() ? prodHost : stagingHost
}

export function getESAPIHost(): string {
	return resolveHost(
		'https://api.equipmentshare.com',
		'https://staging-api.equipmentshare.com'
	)
}

export function getPurchasesAPIHost(): string {
	return resolveHost(
		'https://api.equipmentshare.com/purchases',
		'https://staging-api.equipmentshare.com/purchases'
	)
}

export function getESTrackHost(): string {
	return resolveHost(
		'https://app.estrack.com',
		'https://staging-app.estrack.com'
	)
}

export function getCostCaptureHost(): string {
	return resolveHost(
		'https://costcapture.estrack.com',
		'https://staging-costcapture.estrack.com'
	)
}

export function getInventoryHost(): string {
	return resolveHost(
		'https://inventory.estrack.com',
		'https://staging-inventory.estrack.com'
	)
}

/**
 * Get the URL to create a purchase order from a product list
 * @param productListId - The ID of the product list to create the PO from
 */
export function getCostCapturePurchaseOrderUrl( productListId: string ): string {
	return `${getCostCaptureHost()}/purchase-orders/create-from-product-list/${productListId}`
}

/**
 * Get the URL to a demand request details page
 * @param demandRequestId - The ID of the demand request
 */
export function getDemandRequestUrl( demandRequestId: string ): string {
	return `${getInventoryHost()}/requests/${demandRequestId}`
}

/**
 * Get the URL to view an existing purchase order in CostCapture.
 *
 * CostCapture (procurements-frontend) keys its PO detail route on the internal PO id,
 * not the human PO number — `/purchase-orders/:id/detail`.
 * @param purchaseOrderId - The purchase order's id
 */
export function getCostCapturePurchaseOrderDetailUrl( purchaseOrderId: string ): string {
	return `${getCostCaptureHost()}/purchase-orders/${purchaseOrderId}/detail`
}
